import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Auth, getAuth, onAuthStateChanged, User } from 'firebase/auth';

let cachedUser: User | null | undefined = undefined;
let auth: Auth | null = null;
let listenerSetup = false;

function getAuthLazy(): Auth {
  if (!auth) auth = getAuth();
  return auth;
}

export const rootGuard = async () => {
  const router = inject(Router);
  const authInstance = getAuthLazy();
  if (!listenerSetup) {
    listenerSetup = true;
    onAuthStateChanged(authInstance, (user) => {
      cachedUser = user;
    });
  }

  if (cachedUser !== undefined) {
    return cachedUser ? router.parseUrl('/webshop') : router.parseUrl('/login');
  }

  return new Promise<any>((resolve) => {
    const unsubscribe = onAuthStateChanged(authInstance, (user) => {
      unsubscribe();
      cachedUser = user;
      resolve(user ? router.parseUrl('/webshop') : router.parseUrl('/login'));
    });
  });
};
